import React from 'react';

const Co2Icon = ({
  width = 31,
  height = 31,
  fill = 'none',
  className,
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 62 62' className={className}>
      <g fill={fill} fillRule='evenodd'>
        <path fill='#FFF' d='M38.043 26.724s6.377.661 6.377 7.138c0 6.478-5.559 7.138-5.559 7.138H21.895s-4.155-.33-4.155-5.155c0-4.824 4.564-5.155 4.564-5.155s1.637-.065 2.047.133c0 0 2.107-2.512 4.68-2.512 0 0 2.458.065 3.746 1.52 0 0 2.165-3.107 5.266-3.107zm-15.777 2.777c-.66.047-1.509.256-2.347.687l-.015-.225s-.292-7.204 4.914-7.204c0 0 2.049 0 2.458.727 0 0 .878-1.52 2.691-1.52 0 0 1.756-.067 3.277 1.653 0 0 2.636-.674 3.865 1.996-2.027.34-3.598 1.702-4.45 2.621-1.503-1.023-3.358-1.108-3.602-1.114-2.296-.001-4.208 1.6-5.034 2.419a9.61 9.61 0 0 0-1.117-.052c-.362 0-.64.012-.64.012zm7.71-8.725h-.014a3.97 3.97 0 0 0-1.758.415C28.512 19.696 29.43 18 32.016 18c0 0 3.16.198 3.92 2.247 0 0 .761-.463 1.639-.463.877 0 4.504 1.653 4.037 6.147l-.26.661c-1.092-.602-2.208-.925-3.084-1.034l-.226-.491c-1.084-2.362-3.01-2.714-4.061-2.714-.14 0-.27.006-.384.015-1.583-1.51-3.26-1.592-3.603-1.592h-.017z'
        />
        <circle cx='31' cy='31' r='30.5' stroke='#FFF' />
      </g>
    </svg>
  );
};

export default Co2Icon;


// WEBPACK FOOTER //
// ./src/app/intro/components/Co2Icon/Co2Icon.js